import { render, staticRenderFns } from "./City.vue?vue&type=template&id=35a55b8a"
import script from "./City.vue?vue&type=script&lang=ts"
export * from "./City.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports